"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const classnames_1 = __importDefault(require("classnames"));
const translate_1 = require("components/translate");
const ContentListEmptySearch = ({ t, className }) => {
    return ((0, jsx_runtime_1.jsxs)("section", { className: (0, classnames_1.default)(className, '_text-gray-500 _text-center'), children: [(0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: ['fal', 'search'], className: "_p-6 _rounded-circle _text-6 _border _border-gray-300" }), (0, jsx_runtime_1.jsx)("p", { className: "_mb-2 _text-4", children: t('content_list.search.empty_state_title') }), (0, jsx_runtime_1.jsx)("p", { className: "_mb-0 _text-2", children: t('content_list.search.empty_state_subtitle') })] }));
};
exports.default = (0, translate_1.translate)()(ContentListEmptySearch);
